var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilIcon = function SvgPencilIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "pencil-icon_svg__a",
    d: "M0 15.25V19h3.75L14.81 7.94l-3.75-3.75L0 15.25zM17.71 5.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pencil-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pencil-icon_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.2,
    mask: "url(#pencil-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3-2h24v24H-3z"
  })))));
};
export { SvgPencilIcon as ReactComponent };
export default __webpack_public_path__ + "9e1e2459bf36e4217cfe00816f1d6e29.svg";